import { render, staticRenderFns } from "./socialMobile.vue?vue&type=template&id=06e01940&scoped=true"
import script from "./socialMobile.vue?vue&type=script&lang=js"
export * from "./socialMobile.vue?vue&type=script&lang=js"
import style0 from "./socialMobile.vue?vue&type=style&index=0&id=06e01940&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e01940",
  null
  
)

export default component.exports